import { CardActions, Button, Card, CardContent, CardMedia, Typography, Grid } from "@mui/material";
import CardDialog from "./CardDialog";
import React from 'react'


const StudioCard = ({ name, image, description, duration }) => {

    const [showDialogMenu, togleDialogMenu] = React.useState(false);

    return <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
        <Card sx={{
            height: 320,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }}>

            <CardMedia
                component="img"
                width="100%"
                height="200px"
                image={image}
            />

            <CardContent sx={{ display: "flex", justifyContent: "center" }}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                    sx={{ alignSelf: "center" }}
                >
                    {name}
                </Typography>

            </CardContent>

            <CardActions sx={{ justifyContent: "center" }}>
                <Button onClick={() => togleDialogMenu(true)} size="small">Узнать больше</Button>
            </CardActions>

            <CardDialog
                open={showDialogMenu}
                onClose={() => togleDialogMenu(false)}
                title={name}
                text={description}
                duration={duration}
            />
        </Card>
    </Grid>
}

export default StudioCard;